import { BEGIN_CREATION_PRODUCT, SELECT_ADD_MODEL } from '@/redux/actions/products.actions'

const beginCreationProduct = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'begin creation product process',
		eventAct: action.payload.subFamily,
		eventLbl: ''
	}
}

const selectAddModel = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'select add a model button',
		eventAct: action.payload.subFamily,
		eventLbl: ''
	}
}

export default {
	[BEGIN_CREATION_PRODUCT]: beginCreationProduct,
	[SELECT_ADD_MODEL]: selectAddModel
}
